// used primarily because of shallow compare, because reference is always the same
export const emptyArray = [];
